import { DatasetVariableTypeIdEnum } from "../../../../services/const";
export const VariableTypeLabelOptions = {
    [DatasetVariableTypeIdEnum.STRING]: 'Строка',
    [DatasetVariableTypeIdEnum.NUMBER]: 'Число',
    [DatasetVariableTypeIdEnum.SQL]: 'SQL',
    [DatasetVariableTypeIdEnum.ENTITY]: 'Показатель',
    [DatasetVariableTypeIdEnum.FIELD]: 'Поле'
};
